import React, { useState, useContext, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ProgressBar from "./navbar/ProgressBar";
import { hasPermission } from "../../helperPermissionEditor";
import { LoginContext } from "../../App";
import "./dashboard.css";
import DashboardListing from "./pages/DashboardListing";
import UserListing from "./pages/UserListing";
import RolesListing from "./pages/RolesListing";
import PermissionListing from "./pages/PermissionListing";
import ModelRoleListingPermission from "./pages/roleListingModel/ModelRoleListingPermission";
import ClientListing from "./pages/ClientListing";
import Header from "./navbar/header/Header";
import TikTokListing from "./pages/TikTokListing.jsx";
import TikTokVideosListing from "./pages/TikTokVideosListing.jsx";
import TikTokUserDetails from "./pages/TikTokUserDetails";
import TikTokUserVideosDetails from "./pages/TikTokUserVideosDetails";
import TikTokVideoDetails from "../Dashboard/pages/TikTokVideoDetails";
import TikTokUserStatistics from "./pages/TikTokUserStatistics.jsx";
import TikTokVideoStatistics from "./pages/TikTokVideoStatistics.jsx";
import DailyAPIHits from "./pages/DailyAPIHits.jsx";
import AddTiktokAccounts from "./pages/AddTiktokAccounts.jsx";
import { initializeTokenRefresh } from "../../refershTokenManage/axiosConfig.js";
import HandleTikTokRedirect from "./pages/HandleTikTokRedirect.jsx";
import TikTokVideoUploader from "./pages/TikTokVideoUploader.jsx";

const DashboardIndex = () => {
  const [selectedUserId, setSelectedUserId] = useState(null);
  const { user } = useContext(LoginContext);
  const location = useLocation();
  const from = location.state?.from || "Unknown";

  const handleSelectUser = (userId) => setSelectedUserId(userId);
  useEffect(() => {
    if (localStorage.getItem("token") && from !== "signIn") {
      initializeTokenRefresh();
    }
  }, []);

  return (
    <>
      <div className="dashboard-container">
        <ProgressBar />
        <div className="overlay" />
        <div className="dashboard content">
          <Header />
          <Routes>
            <Route path="/" exact element={<Navigate to="/dashboard" />} />

            <Route path="/dashboard" element={<DashboardListing />} />

            <Route path="/auth/tiktok/callback" element={<HandleTikTokRedirect />} />

            {hasPermission(user.permissions, "view-user") && (
              <Route path="/userListing" element={<UserListing />} />
            )}

            {hasPermission(user.permissions, "view-role") && (
              <Route
                path="/rolelist"
                element={<RolesListing onUserSelect={handleSelectUser} />}
              />
            )}

            {hasPermission(user.permissions, "view-permission") && (
              <Route path="/permissionlist" element={<PermissionListing />} />
            )}

            {hasPermission(user.permissions, "view-client") && (
              <Route path="/clientListing" element={<ClientListing />} />
            )}

            {hasPermission(user.permissions, "view-role") && (
              <Route
                path="/rolelist"
                element={<RolesListing onUserSelect={handleSelectUser} />}
              />
            )}

            {hasPermission(user.permissions, "view-permission") && (
              <Route path="/permissionlist" element={<PermissionListing />} />
            )}

            {hasPermission(user.permissions, "view-role") && (
              <Route
                path="/modelListing"
                element={<ModelRoleListingPermission userId={selectedUserId} />}
              />
            )}

            {localStorage.getItem("userRole") === "client" && (
              <Route path="/add-tiktoks" element={<AddTiktokAccounts />} />
            )}

            {/* Open routes */}
            <Route path="/tiktokAccounts" element={<TikTokListing />} />
            <Route path="/tiktokVideos" element={<TikTokVideosListing />} />
            <Route
              path="/Tiktok-statistics/:tiktokId"
              element={<TikTokUserStatistics />}
              exact
            />
            <Route
              path="/Tiktok-video-statistics/:videoId"
              element={<TikTokVideoStatistics />}
              exact
            />
            <Route
              path="/Tiktok-UserDetails/:tiktokId"
              element={<TikTokUserDetails />}
            />
            <Route
              path="/Tiktok-UsersDetails/:tiktokId/videos"
              element={<TikTokUserVideosDetails />}
              exact
            />
            <Route
              path="/Tiktok-video/:videoId"
              element={<TikTokVideoDetails />}
              exact
            />

            <Route path="/totalApiHits" element={<DailyAPIHits />} />

            <Route path="/upload-video/:tiktokId" element={<TikTokVideoUploader />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
      <footer className="footer">
        <div className="footer-text">
          © {new Date().getFullYear()} Infynalytics. All rights reserved.
        </div >
        <div className="footer-links">
          Version {process.env.REACT_APP_VERSION_CONTROL}
        </div>
      </footer >
    </>
  );
};

export default DashboardIndex;
